module.exports = __webpack_public_path__ + "img/hikPark.ef45bdfb.jpg";